/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {
  HlpRestService,
  UserRestService,
  UserDetailsShortDto,
  ListingStatus,
} from '@gh/builder-shared-data';
import { DictionaryService, getRouteQueryParam, InitViewService } from '@gh/common-shared';
import { GridLayoutService } from '@gh/core-ui-grid';
import { BuilderUserContext, FilterNames, FilterRestService } from '@gh/builder-shared';
import { Observable } from 'rxjs';
import { FilteredDataQuery, getSlicedData, SlicedDataSource } from '@gh/core-data';
import {
  HlpListItem,
} from './hlp.model';
import { map$, switchMap$ } from '@gh/rx/operators';
import { ID } from '@gh/common-shared-data';
import { combineLatest$, of$ } from '@gh/rx';

@Injectable()
export class HlpListBusinessService implements InitViewService {

  constructor(private userContext: BuilderUserContext,
              private hlpRest: HlpRestService,
              private userRest: UserRestService,
              private dictionaries: DictionaryService,
              private filterService: FilterRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return this.filterService.get(FilterNames.hlpList).pipe(switchMap$((filter) => combineLatest$([
                                                    this.gridLayoutService.get('hlpList'),
                                                    of$(getRouteQueryParam(route, 'createLeadQuote')),
                                                    of$(getRouteQueryParam(route, 'clonedHlp')),
                                                    filter.salesPersonId ? this.getSalesPerson(filter.salesPersonId) : of$({name: 'All', id: ''}),
                                                  ]).pipe(map$(([gridLayout, createLeadQuote, clonedHlp, salesPerson]) => ({
      gridLayout, createLeadQuote, clonedHlp, salesPerson, filter,
    })))));
  }

  findAllAsDataSource(filter: any): SlicedDataSource<HlpListItem> {
    return this.hlpRest.findAllAsDataSource(filter);
  }

  findSalesPersonsByName(query: FilteredDataQuery<string>, filter: any): Observable<UserDetailsShortDto[]> {
    return this.userRest.findSalespersonsAsDataSource({
      ...filter,
      searchString: query.filter,
    }).select(query).pipe(map$(getSlicedData));
  }

  delete(id: ID, listingStatus?: ListingStatus): Observable<any> {
    return this.hlpRest.delete(id, listingStatus);
  }

  getSalesPerson(id: ID): Observable<any> {
    return this.userRest.get(id).pipe(map$((user) => ({
      id: user.userId,
      name: user.contact?.name,
    })));
  }
}
